import { Navigate } from "react-router-dom";
import { usePlatformAdmin } from "@/hooks/usePlatformAdmin";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

interface PlatformAdminRouteProps {
  children: React.ReactNode;
}

export function PlatformAdminRoute({ children }: PlatformAdminRouteProps) {
  const { user, loading } = useAuth();
  const { isPlatformAdmin, isLoading: adminLoading } = usePlatformAdmin();

  if (loading || adminLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!isPlatformAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
